// Use same-origin API calls when deployed (avoids CORS issues)
// Falls back to REACT_APP_BACKEND_URL for local dev / preview
const getApiBase = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    // On deployed site, use same origin to avoid CORS
    return window.location.origin;
  }
  return envUrl || '';
};

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;

const TOKEN_KEY = 'petsbox_session_token';

export function getAuthHeaders() {
  const headers = {};
  try {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) headers['Authorization'] = `Bearer ${token}`;
  } catch {}
  return headers;
}

export function authOpts(opts = {}) {
  return {
    ...opts,
    credentials: 'include',
    headers: { ...getAuthHeaders(), ...(opts.headers || {}) },
  };
}
